import React, { useEffect, useRef } from 'react';
import './StarBackground.css';

const StarBackground = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create stars
    const createStars = (count, className) => {
      for (let i = 0; i < count; i++) {
        const star = document.createElement('div');
        star.className = `star ${className}`;
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 100}%`;
        star.style.animationDelay = `${Math.random() * 3}s`;
        star.style.animationDuration = `${2 + Math.random() * 3}s`;
        container.appendChild(star);
      }
    };

    createStars(50, 'star-small');
    createStars(30, 'star-medium');
    createStars(15, 'star-large');

    // Cleanup
    return () => {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }, []);

  return (
    <div className="star-background" ref={containerRef}>
      <div className="nebula nebula-1"></div>
      <div className="nebula nebula-2"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star shooting-star-2"></div>
    </div>
  );
};

export default StarBackground;
